import { useAuth } from "./use-auth"

interface DirectoryAdminResult {
  isAdmin: boolean
  isLoading: boolean
}

export function useDirectoryAdmin(): DirectoryAdminResult {
  const { session, isLoading } = useAuth()

  if (isLoading) {
    return { isAdmin: false, isLoading: true }
  }

  // Local dev: session is null when VITE_LOCAL_USER_EMAIL is set.
  // The local API grants directory-admin to every local user.
  if (session === null) {
    return { isAdmin: !!import.meta.env.VITE_LOCAL_USER_EMAIL, isLoading: false }
  }

  const groups = session.tokens?.accessToken?.payload?.["cognito:groups"]
  if (!Array.isArray(groups)) return { isAdmin: false, isLoading: false }

  return { isAdmin: groups.includes("directory-admin"), isLoading: false }
}
